import { render, staticRenderFns } from "./NavigationMenuItem.vue?vue&type=template&id=6eec019a&scoped=true"
import script from "./NavigationMenuItem.vue?vue&type=script&lang=js"
export * from "./NavigationMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eec019a",
  null
  
)

export default component.exports